import TableSearch from "@/views/dashboard/shared/tableSearch/tableSearch.vue";
import CreatePromoCodeModal from "../createPromoCodeModal/createPromoCodeModal.vue";
import PromoCodeApi from "@/services/api/promoCodeApi";

const PromoCodeApiService = new PromoCodeApi(),
  FIRST_PAGE = 1;

export default {
  components: {
    TableSearch,
    CreatePromoCodeModal,
  },

  data() {
    return {
      query: "",
      isTypingSearchQuery: false,
      results: [],
      code_id: null,
      pagination: {
        page: 1,
        limit: 12,
        total: 0,
      },
      createPromoCodeModalVisible: false,
      statuses: [],
      selectedStatus: null,
    };
  },

  methods: {
    getPromoCodeStatuses,
    statusChangeCallback,
    search,
    getPromoCodes,
    openEditPromoCodeModal,
    closeCreatePromoCodeModal,
  },

  async mounted() {
    this.getPromoCodeStatuses();
    this.getPromoCodes();
  },
};

function statusChangeCallback(val) {
  if (val.name === "ALL") {
    this.selectedStatus = null;
  } else {
    this.selectedStatus = val.value;
  }

  this.pagination.page = FIRST_PAGE;
  this.getPromoCodes();
}

function openEditPromoCodeModal(id) {
  this.code_id = id;
  this.createPromoCodeModalVisible = true;
}

function closeCreatePromoCodeModal(fetch) {
  this.createPromoCodeModalVisible = false;
  this.code_id = null;

  if (fetch) {
    this.pagination.page = FIRST_PAGE;
    this.getPromoCodes();
  }
}

function search(value) {
  this.pagination.page = FIRST_PAGE;
  this.query = value;

  this.getPromoCodes();
}

function getPromoCodes(page) {
  if (page) {
    this.pagination.page = Number(page);
  }

  const request = {
    page: this.pagination.page - FIRST_PAGE,
    size: this.pagination.limit,
    keyword: this.query,
    brand_id: "",
    status: this.selectedStatus ? this.selectedStatus : "",
  };

  PromoCodeApiService.get(request)
    .then(({ data }) => {
      this.results = data.promo_codes;
      this.pagination.total = data.total;
    })
    .catch((error) => {
      this.$utils.handleError(this, error);
    });
}

async function getPromoCodeStatuses() {
  const { data } = await PromoCodeApiService.getPromoCodeStatuses();

  data.options.forEach((status) => {
    this.statuses.push({
      name: status.label,
      value: status.value,
    });
  });
  this.statuses.unshift({
    name: "ALL",
  });
}
